import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/nominal-effective-rate',
  component: () => import('../../routes/NominalEffective.svelte'),
  card: {
    id: 'nominal-effective-rate',
    title: 'Nominal vs Effective Rate',
    description: 'Compare stated (nominal) annual interest rates against true effective annual rates based on compounding frequency. Understand the real cost of loans and true yield of investments.',
    icon: 'sync_alt',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/nominal-effective-rate',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Nominal vs Effective Interest Rate Calculator – Compare Stated vs True Annual Rates',
    description: 'Free nominal vs effective interest rate calculator. Convert stated annual rates to true effective annual rates based on compounding frequency. See year-by-year impact of compound interest.',
  },
};

export default meta;
